import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchUserProperties = createAction(constants.FETCH_USER_PROPERTIES)
export const fetchUserPropertiesPending = createAction(constants.FETCH_USER_PROPERTIES_PENDING)
export const fetchUserPropertiesCancelled = createAction(constants.FETCH_USER_PROPERTIES_CANCELLED)
export const fetchUserPropertiesFailed = createAction(constants.FETCH_USER_PROPERTIES_FAILED)

export const updateUserPropertiesTheRightWay = (properties, doNotify) => dispatch => dispatch({
  type: constants.UPDATE_USER_PROPERTIES,
  payload: {
    notify: !!doNotify,
    properties
  }
})

export const updateUserProperties = createAction(constants.UPDATE_USER_PROPERTIES)
export const updateExtensionUserProperty = createAction(constants.UPDATE_EXTENSION_USER_PROPERTIES)
export const updateClassificationsNotificationProperties = createAction(constants.UPDATE_CLASSIFICATIONS_NOTIFICATION_PROPERTIES)
export const updateOutboundNotificationProperties = createAction(constants.UPDATE_OUTBOUND_NOTIFICATION_PROPERTIES)

export const updateUserPropertiesPending = createAction(constants.UPDATE_USER_PROPERTIES_PENDING)
export const updateUserPropertiesCancelled = createAction(constants.UPDATE_USER_PROPERTIES_CANCELLED)
export const updateUserPropertiesFailed = createAction(constants.UPDATE_USER_PROPERTIES_FAILED)

export const receiveUserProperties = createAction(constants.RECEIVE_USER_PROPERTIES)

export const fetchUsersByPropertyName = createAction(constants.FETCH_USERS_BY_PROPERTY_NAME)
export const fetchUsersByPropertyNamePending = createAction(constants.FETCH_USERS_BY_PROPERTY_NAME_PENDING)
export const fetchUsersByPropertyNameSuccess = createAction(constants.FETCH_USERS_BY_PROPERTY_NAME_SUCCESS)
export const fetchUsersByPropertyNameFailure = createAction(constants.FETCH_USERS_BY_PROPERTY_NAME_FAILURE)

export const userAtConversationLimitUpdate = createAction(constants.USER_AT_CONVERSATION_LIMIT)




// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/properties/actions.js